import { api } from "@/lib/api";

export function pushSupported() {
    return (
        typeof window !== "undefined" &&
        "serviceWorker" in navigator &&
        "PushManager" in window &&
        "Notification" in window
    );
}

function urlBase64ToUint8Array(base64String) {
    const padding = "=".repeat((4 - (base64String.length % 4)) % 4);
    const base64 = (base64String + padding).replace(/-/g, "+").replace(/_/g, "/");
    const raw = window.atob(base64);
    const out = new Uint8Array(raw.length);
    for (let i = 0; i < raw.length; i++) out[i] = raw.charCodeAt(i);
    return out;
}

export async function getExistingSubscription() {
    if (!pushSupported()) return null;
    const reg = await navigator.serviceWorker.getRegistration();
    if (!reg) return null;
    return reg.pushManager.getSubscription();
}

export async function enablePush() {
    if (!pushSupported()) throw new Error("unsupported");
    const permission = await Notification.requestPermission();
    if (permission !== "granted") throw new Error("denied");
    const reg = await navigator.serviceWorker.register("/sw.js");
    await navigator.serviceWorker.ready;
    const { data } = await api.get("/push/public-key");
    if (!data.public_key) throw new Error("no-key");
    let sub = await reg.pushManager.getSubscription();
    if (!sub) {
        sub = await reg.pushManager.subscribe({
            userVisibleOnly: true,
            applicationServerKey: urlBase64ToUint8Array(data.public_key),
        });
    }
    const json = sub.toJSON();
    await api.post("/push/subscribe", { endpoint: json.endpoint, keys: json.keys });
    return true;
}

export async function disablePush() {
    const sub = await getExistingSubscription();
    if (sub) {
        const json = sub.toJSON();
        try {
            await api.post("/push/unsubscribe", { endpoint: json.endpoint });
        } catch (e) { /* ignore */ }
        await sub.unsubscribe();
    }
}
